<p-dialog
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '56rem', maxWidth: '95vw' }"
  [header]="headerTitle()">

  <div *ngIf="error()" class="text-red-500 text-sm mb-3">{{ error() }}</div>

  <p-table
    [value]="trails()"
    [totalRecords]="totalRecords()"
    [paginator]="true"
    [rows]="rows()"
    [first]="first()"
    [lazy]="true"
    [loading]="loading()"
    [loadingIcon]="'pi pi-spin pi-cog'"
    [tableStyle]="{ 'min-width': '40rem' }"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    paginatorDropdownAppendTo="body"
    [rowsPerPageOptions]="[10, 25, 50]"
    (onPage)="onPage($event)"
    size="small">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 8rem">Action</th>
        <th>Description</th>
        <th style="width: 10rem">Username</th>
        <th style="width: 10rem">Created At</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-trail>
      <tr>
        <td>
          <p-tag [value]="trail.action" [severity]="actionSeverity(trail.action)"></p-tag>
        </td>
        <td>{{ trail.description }}</td>
        <td>{{ trail.username }}</td>
        <td>{{ trail.created_at | date:'dd/MM/yyyy HH:mm' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="text-center p-4">
          {{ loading() ? 'Loading…' : 'No audit history found for this record' }}
        </td>
      </tr>
    </ng-template>
  </p-table>

  <ng-template pTemplate="footer">
    <p-button
      label="Close"
      icon="pi pi-times"
      (onClick)="visible.set(false)"
      styleClass="p-button-text"
      size="small">
    </p-button>
  </ng-template>
</p-dialog>
